import { provideWidgetClass } from "scrivito"

export const DataWidget = provideWidgetClass("DataWidget", {
  attributes: {
    content: "widgetlist",
    reverse: "boolean"
  }
})
